var render, staticRenderFns
import script from "./ArtisanMenu.vue?vue&type=script&lang=js"
export * from "./ArtisanMenu.vue?vue&type=script&lang=js"
import style0 from "./ArtisanMenu.vue?vue&type=style&index=0&id=e1bb8a36&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1bb8a36",
  null
  
)

export default component.exports